import { openDB } from "idb";

export const dbPromise = openDB("videoUploads", 1, {
  upgrade(db) {
    db.createObjectStore("videos");
  },
});

export async function saveVideo(uploadId: string, file: File) {
  const db = await dbPromise;
  await db.put("videos", file, uploadId);
}

export async function getVideo(uploadId: string) {
  const db = await dbPromise;
  return db.get("videos", uploadId);
}

export async function removeVideo(uploadId: string) {
  const db = await dbPromise;
  await db.delete("videos", uploadId);
}